







import {Component, Prop, Vue} from 'vue-property-decorator';
import {SshKey} from '@/interfaces/interfaces';

@Component
export default class KeyBox extends Vue {
  @Prop() private sshKey!: SshKey;
}
